import getName from "../../../../common/helpers/getName";
import { IPackState } from "../models";
import { PackActionTypes } from "../models/packActions";
import {
    GET_PACK,
    RENAME_PLAN,
    NEW_PLAN,
    DELETE_PLAN,
    DUPLICATE_PRIVATE_PLAN,
    CHANGE_PACK_PLAN_COPY,
    CHANGE_PACK_SORTING,
} from "../types";

export default (pack: IPackState = { sorting: "modified" }, action: PackActionTypes): IPackState => {
    let data, plans, plan, index;
    switch (action.type) {
        case GET_PACK:
            if (action.payload.loading) {
                return { sorting: pack.sorting, loading: true };
            }
            if (action.payload.error) {
                return { sorting: pack.sorting, error: true };
            }
            return { ...pack, _id: action.packId, plans: action.payload.data!.plans };
        case RENAME_PLAN:
            data = action.payload.data;
            const { planId, name } = data;
            plans = pack.plans!;
            index = plans.findIndex(plan => plan._id === planId);
            plans[index].name = name;
            return { ...pack };
        case NEW_PLAN:
            data = action.payload.data;
            plans = pack.plans!;
            if (data.limit) return pack;
            plan = data.plan!;
            plans.push(plan);
            return { ...pack };
        case DUPLICATE_PRIVATE_PLAN:
            data = action.payload.data;
            plans = pack.plans!;
            if (data.limit) return pack;
            plan = data.plan!;
            plans.push(plan);
            return { ...pack };
        case DELETE_PLAN:
            plans = pack.plans;
            plans!.splice(action.payload.index, 1);
            return { ...pack };
        case CHANGE_PACK_PLAN_COPY:
            plans = pack.plans!;
            index = plans.findIndex(plan => plan._id === action.payload.planId);
            plan = plans[index];
            plan.copyright = action.payload.copyright;
            return { ...pack };
        case CHANGE_PACK_SORTING:
            plans = pack.plans!;
            if (pack.plans) {
                if (action.payload.sorting === "abc" || action.payload.sorting === "listed") {
                    plans = plans.sort((a, b) =>
                        getName(a.name, { locale: action.payload.lang }).localeCompare(
                            getName(b.name, { locale: action.payload.lang })
                        )
                    );
                    if (action.payload.sorting === "listed") {
                        plans = [
                            ...plans.filter(plan => plan.accepted),
                            ...plans.filter(plan => !plan.accepted && plan.public),
                            ...plans.filter(plan => !plan.accepted && !plan.public && plan.shared),
                            ...plans.filter(plan => !plan.shared),
                        ];
                    }
                } else {
                    plans = plans.sort((a, b) => b[action.payload.sorting as "modified" | "created"]! - a[action.payload.sorting as "modified" | "created"]!);
                }
            }
            return { ...pack, plans, sorting: action.payload.sorting };
        default:
            return pack;
    }
};
